AddPageSwapTrigger(function() {
    function checkEmail(strEmail) {
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(strEmail)) {
            return true;
        }
        return false;
    }

    $("div.modal").each(function() {
        var $that = $(this);

        var email_verified = false;
        var verifying_email = false;
        var conditions_agreed = false;
        var newsletter_valid = false;

        var timeout_duration = 2000;
        var timeout = null;
        var timeout_name = null;
        var timeout_email = null;
        var captcha_token = "";

        var blacklist = [
            '@hotmail.',
            '@gmail.com',
			'@gmail.co',
			'@gmail.con',
            'alumnus',
   //         'alumni',
			'cursist',
			'leerling',
            '@yahoo.',
            '@aol.',
            '@msn.',
            '@outlook.com',
            '@outlook.de',
            '@icloud.com',
            '@me.com',
            '@gmx.',
            '@zoho.',
            '@mail.com',
            '@yandex.com',
            '@inbox.com',
            '@zoho.com',
			'@live.com',
			'@live.co.uk',
			'@live.nl',
			'@live.be',
			'@live.de',
			'@live.at',
			'@live.it',
			'@live.es',
			'@live.fr',
			'@edu.ps',
			'@example.com',
			'.student.nl',
			'.student.be',
			'.student.com',
			'.student.co.uk',
			'.student.uk',
			'.student.de',
			'.student.net',
			'.student.org',
			'.stud.nl',
			'.stud.be',
			'.stud.com',
			'.stud.co.uk',
			'.stud.uk',
			'.stud.de',
			'.stud.net',
			'.stud.org',
			'.sch.uk',
			'@web.de',
			'@t-online.de',
			'@kpnmail.nl',
			'@ziggo.nl',
			'@upcmail.nl',
			'@home.nl',
			'@nthrl.com',
			'@telenet.be',
			'@qq.com',
			'@mail.ru',
            '@protonmail.com'
        ];


        var code = $that.find('.modal-dialog-verify').data('code-requested');
        var shopId = $that.find('.modal-dialog-verify').data('shopid-requested');
        var link = $that.find('.modal-dialog-verify').data('link-requested');

        var resendVerify = function (event) {
            event.preventDefault()
            event.stopImmediatePropagation()

            var action = 'resend_verify'
            if (typeof event.data[0] !== "undefined")
                action = event.data[0]

            if (typeof event.data[1] !== "undefined")
                result = event.data[1]

            captcha(action, function (token) {
                $.post(inPath() + 'live/codes/providers/resend-mail/' + result.id + '/' + result.hash, {
                    email: $that.find('#verification-email').val(),
                    token: token,
                }).then(function () {
                    $that.find('.verification-result').hide()
                    $that.find('.verification-steps').find('.active').removeClass('active');
                    $that.find('.verification-steps .step2').closest('div').addClass('active');
                    $that.find('#verification-form-div').hide();
                    $that.find('#verification-result-div .resend-verify').hide()
                    $that.find('#verification-result-div').show();
                })
            })

            $(this).hide()
        }

        var onBlackList = function(email) {
            for(var i in blacklist) {
                if(email.toLowerCase().includes(blacklist[i])) {
                    return true;
                }
            }
            return false;
        }

        var enableSubmit = function() {
            if(verifying_email) {
                $that.find('#verification-email-form-group').removeClass('has-error');
                $that.find('#verification-email-form-group').addClass('has-pending');
                $that.find('#verification-email-form-group').removeClass('has-success');
            }
            else if($that.find('#verification-email').val().length == 0) {
                $that.find('#verification-email-form-group').removeClass('has-error');
                $that.find('#verification-email-form-group').removeClass('has-pending');
                $that.find('#verification-email-form-group').removeClass('has-success');
            }
            else if(email_verified) {
                $that.find('#verification-email-form-group').removeClass('has-error');
                $that.find('#verification-email-form-group').removeClass('has-pending');
                $that.find('#verification-email-form-group').addClass('has-success');
            }
            else {
                $that.find('#verification-email-form-group').addClass('has-error');
                $that.find('#verification-email-form-group').removeClass('has-pending');
                $that.find('#verification-email-form-group').removeClass('has-success');

            }
            if(email_verified && conditions_agreed && newsletter_valid) {
                $that.find('#verification-submit-button').attr('disabled', false);
                $that.find('#verification-submit-button').removeClass('verification-submit-button-disabled');
            }
            else {
                $that.find('#verification-submit-button').attr('disabled', true);
                $that.find('#verification-submit-button').addClass('verification-submit-button-disabled');
            }
        }

        var verifyEmail = function() {
            email_verified = false;
            var email = $that.find('#verification-email').val();

            if(email.length == 0) {
                $that.find('.verification-result').hide();
                // $that.find('#verification-invalid-email').show();
                enableSubmit();
                return false;

            }
            if(!checkEmail(email)) {
                $that.find('.verification-result').hide();
                $that.find('#verification-invalid-email').show();
                enableSubmit();
                return false;
            }
            if(onBlackList(email)) {
                $that.find('.verification-result').hide();
                $that.find('#verification-not-listed').show();
                enableSubmit();
                return false;
            }


            $that.find('#verification-email-form-group').removeClass('has-error');
            $that.find('#verification-email-form-group').addClass('has-pending');
            $that.find('#verification-email-form-group').removeClass('has-success');
            verifying_email = true;
            $.post(inPath() + 'live/codes/providers/verify-email', {
                email: email,
                code: code
            }, function(result) {
                verifying_email = false;
                if(result.message == 'success' && email == $that.find('#verification-email').val()) {
                    $that.find('.verification-result').hide();
                    $that.find('#verification-' + result.message).show();
                    email_verified =true;
                }
                else if(email == $that.find('#verification-email').val()) {
                    $that.find('.verification-result').hide();
                    $that.find('#verification-' + result.message).show();
                }

                if ('used' == result.message) {
                    email_verified = true
                    if (typeof result.id !== 'undefined' && typeof result.hash !== 'undefined' && $that.find('#verification-used .resend-verify').length > 0) {
                        $that.find('#verification-used .resend-verify').prop('disabled', true).show()
                        countdown(typeof result.seconds_left != 'undefined' && result.seconds_left > 0 ? result.seconds_left : 0, '#verification-used .resend-verify .countdown', function () {
                            $('#verification-used').find('button.resend-verify')
                                .prop('disabled', false)
                                .off('click', resendVerify) // remove old listener
                                .on('click', ['resend_verify_used', result], resendVerify) // add listener
                        })
                    } else {
                        $that.find('#verification-used .resend-verify').hide()
                    }
                }

                enableSubmit();
            }, "json");

        }

        var subscribeToNewsletter = function() {
            var form = $that.find('#verification-newsletter-name-form-group').closest('form');
            var formdata = form.serialize();
            // formdata += '&token=' + encodeURIComponent(token);
            formdata += "&CustomFields[468]=" + encodeURIComponent($that.find('.modal-dialog-verify').data('verification-newsletter-result-url') +
                'account=' + encodeURIComponent(btoa(
                    'voornaam=' + form.find('.nieuwsbrief_voornaam').val() +
                    '&email=' + form.find('.nieuwsbrief_email').val()))

            );

            $.post($that.find('.modal-dialog-verify').data('verification-newsletter-action-url'), formdata, function (data) {
                if (/Captcha failed/.test(data)) {
                    alert("Er is iets misgegaan met de captcha controle, ververs de pagina en probeer opnieuw");
                }
                else if (/Uw inschrijving is bijna voltooid/.test(data)) { // succesvol ingeschreven
                    $that.find('.verification-steps').find('.active').removeClass('active');
                    $that.find('.verification-steps .step2').closest('div').addClass('active');
                    $that.find('#verification-form-div').hide();
                    $that.find('#verification-newsletter-result-div').show();
                    $.cookie('nieuwsbrief_voornaam', form.find('.nieuwsbrief_voornaam').val(), {
                        expires: 1000,
                        path: '/'
                    });
                    $.cookie('nieuwsbrief_email', form.find('.nieuwsbrief_email').val(), {
                        expires: 1000,
                        path: '/'
                    });
                }
                else if (/Uw inschrijving is nu voltooid/.test(data)) { // succesvol ingeschreven
                    $that.find('.verification-steps').find('.active').removeClass('active');
                    $that.find('.verification-steps .step2').closest('div').addClass('active');
                    $that.find('#verification-form-div').hide();
                    $that.find('#verification-result-div').show();
                    $.cookie('nieuwsbrief_voornaam', form.find('.nieuwsbrief_voornaam').val(), {
                        expires: 1000,
                        path: '/'
                    });
                    $.cookie('nieuwsbrief_email', form.find('.nieuwsbrief_email').val(), {
                        expires: 1000,
                        path: '/'
                    });
                }
                else if (
                    /Hi welkom terug/.test(data) ||
                    /error=<br\/>-(.+) NL - Nieuwsbrief"/.test(data)
                ) { // email bestaat reeds
                    $that.find('.verification-steps').find('.active').removeClass('active');
                    $that.find('.verification-steps .step2').closest('div').addClass('active');
                    $that.find('#verification-form-div').hide();
                    $that.find('#verification-result-div').show();
                    $.cookie('nieuwsbrief_voornaam', form.find('.nieuwsbrief_voornaam').val(), {
                        expires: 1000,
                        path: '/'
                    });
                    $.cookie('nieuwsbrief_email', form.find('.nieuwsbrief_email').val(), {
                        expires: 1000,
                        path: '/'
                    });
                }
                else { // fout opgetreden
                    alert("Er is een onbekende fout opgetreden");
                }
            });
        }

        var newsletterValid = function() {
            if( checkEmail($that.find('#verification-newsletter-email-form-group input').val()) &&
                $that.find('#verification-newsletter-name-form-group input').val().length > 2 &&
                $that.find('#verification-newsletter-city-form-group select').val() != ''
            ) {
                newsletter_valid = true;
            }
            else {
                newsletter_valid = false;
            }
            enableSubmit();
        }

        var checkName = function() {

            if($that.find('#verification-newsletter-name-form-group input').val().length == 0) {
                $that.find('#verification-newsletter-name-form-group').removeClass('has-error');
                $that.find('#verification-newsletter-name-form-group').removeClass('has-success');
            }
            else if($that.find('#verification-newsletter-name-form-group input').val().length > 2) {
                $that.find('#verification-newsletter-name-form-group').addClass('has-success');
                $that.find('#verification-newsletter-name-form-group').removeClass('has-error');
            }
            else {
                $that.find('#verification-newsletter-name-form-group').addClass('has-error');
                $that.find('#verification-newsletter-name-form-group').removeClass('has-success');
            }

            newsletterValid();
        }

        var checkNewsletterEmail = function() {

            if($that.find('#verification-newsletter-email-form-group input').val().length == 0) {
                $that.find('#verification-newsletter-email-form-group').removeClass('has-error');
                $that.find('#verification-newsletter-email-form-group').removeClass('has-success');
            }
            else if(checkEmail($that.find('#verification-newsletter-email-form-group input').val())) {
                $that.find('#verification-newsletter-email-form-group').addClass('has-success');
                $that.find('#verification-newsletter-email-form-group').removeClass('has-error');
            }
            else {
                $that.find('#verification-newsletter-email-form-group').addClass('has-error');
                $that.find('#verification-newsletter-email-form-group').removeClass('has-success');
            }

            newsletterValid();
        }

        $that.find('#verification-newsletter-city-form-group select').change(function() {
            if($that.find('#verification-newsletter-city-form-group select').val() != '') {
                $that.find('#verification-newsletter-city-form-group').addClass('has-success');
                $that.find('#verification-newsletter-city-form-group').removeClass('has-error');
            }
            else {
                $that.find('#verification-newsletter-city-form-group').removeClass('has-success');
                $that.find('#verification-newsletter-city-form-group').addClass('has-error');
            }
            newsletterValid();
        });

        $that.find('#verification-newsletter-name-form-group input').keyup(function() {
            $that.find('#verification-newsletter-name-form-group').removeClass('has-error');
            $that.find('#verification-newsletter-name-form-group').removeClass('has-success');

            if(timeout_name) clearTimeout(timeout_name);

            if($(this).val() == "") {
                checkName();
            }
            else {
                timeout_name = setTimeout(checkName, timeout_duration);
            }
        });

        $that.find('#verification-newsletter-email-form-group input').keyup(function() {
            $that.find('#verification-newsletter-email-form-group').removeClass('has-error');
            $that.find('#verification-newsletter-email-form-group').removeClass('has-success');

            if(timeout_email) clearTimeout(timeout_name);

            if($(this).val() == "") {
                checkNewsletterEmail();
            }
            else {
                timeout_email = setTimeout(checkNewsletterEmail, timeout_duration);
            }
        });

        $that.find('#verification-email').keyup(function() {
            $that.find('#verification-email-form-group').removeClass('has-error');
            $that.find('#verification-email-form-group').removeClass('has-pending');
            $that.find('#verification-email-form-group').removeClass('has-success');
            $that.find('.verification-result').hide();

            if(timeout) clearTimeout(timeout);

            timeout = setTimeout(verifyEmail, timeout_duration);
        });

        $that.find('#verification-email').blur(function() {
            if (email_verified) return
            $that.find('#verification-email-form-group').removeClass('has-error');
            $that.find('#verification-email-form-group').removeClass('has-pending');
            $that.find('#verification-email-form-group').removeClass('has-success');
            $that.find('.verification-result').hide();

            if(timeout) clearTimeout(timeout);

            verifyEmail();
        });

        $that.find('#verification-submit-button').click(function() {
            var email = $that.find('#verification-email').val();
            var newsletter_name = $that.find('#verification-newsletter-name-form-group input').val();
            var newsletter_email = $that.find('#verification-newsletter-email-form-group input').val();
            var newsletter_city = $that.find('#verification-newsletter-city-form-group select').val();

            $that.find('.result-verification-email').text(email);
            $that.find('.result-newsletter-email').text(newsletter_email);


            // var loaders = $('<img class="mask" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12P4vwwAAqcBptMosmkAAAAASUVORK5CYII=" />');
            var loaders = $('<span class="loader"><img class="mask" width="50" height="50" src="' + window.location.protocol + '//' + window.location.host.replace('www.','cdn.') + '/assets/img/loading-product-zwart.svg" /></span>');

            loaders.css('display', 'block');
            loaders.css('position', 'fixed');
            loaders.css('top', '0px');
            loaders.css('bottom', '0px');
            loaders.css('left', '0px');
            loaders.css('right', '0px');
            loaders.css('zIndex', '1');
            loaders.css('background', 'rgba(255,255,255,0.5)');
            loaders.css('textAlign', 'center');

            loaders.find('img').css('top','50%');
            loaders.find('img').css('left','50%');
            loaders.find('img').css('transform','translate(-50%, -50%)');
            loaders.find('img').css('position','absolute');

            $('.modal.in .modal-header').prepend(loaders);
            $that.find('#verification-submit-button').addClass('verification-submit-button-disabled');
            captcha('mail_code', function(token) {
                captcha_token = token;
                $.post(inPath() + 'live/codes/providers/send-mail', {
                    email: email,
                    code: code,
                    shop_id: shopId,
                    link: link,
                    hash: document.location.hash,
                    token: captcha_token
                }, function (result) {
                    loaders.remove();
                    $that.find('#verification-submit-button').removeClass('verification-submit-button-disabled');
                    $that.find('.verification-result').hide();
                    $that.find('#verification-' + result.message).show();

                    if (result.message == 'success') {

                        if ($that.find('#verification-newsletter').is(':checked')) {
                            subscribeToNewsletter();
                        }
                        else {
                            $that.find('.verification-steps').find('.active').removeClass('active');
                            $that.find('.verification-steps .step2').closest('div').addClass('active');
                            $that.find('#verification-form-div').hide();
                            $that.find('#verification-result-div').show();
                        }
                    }

                    if (typeof result.id !== 'undefined' && typeof result.hash !== 'undefined') {
                        $that.find('button.resend-verify').prop('disabled', true).show()

                        countdown(typeof result.seconds_left !== 'undefined' ? result.seconds_left : 60, '.verification-well-footer > .resend-verify .countdown', function () {
                            $that.find('button.resend-verify')
                                .prop('disabled', false)
                                .off('click', resendVerify) // remove old listener
                                .on('click', ['resend_verify', result], resendVerify) // add listener
                        })
                    }

                    enableSubmit();
                }, "json");
            });
        })

        $that.find('.modal-dialog-verify .mcheck input').click(function() {
            if($(this).is(':checked')) {
                $(this).parents('.mcheck:first').addClass('checked');
            }
            else {
                $(this).parents('.mcheck:first').removeClass('checked');
            }

            if($that.find('#verification-conditions').is(':checked')) {
                conditions_agreed = true;
            }
            else {
                conditions_agreed = false;
            }

            if($that.find('#verification-newsletter').is(':checked')) {
                $that.find('.verification-newsletter-form').show();
                newsletterValid();
            }
            else {
                newsletter_valid = true;
                $that.find('.verification-newsletter-form').hide();
            }

            enableSubmit();
        });

        var fncError = function(el) {
            el.css('border', '1px solid rgb(204, 0, 0)');
            el.focus(function() { fncReleaseError(el); });
        }

        var fncReleaseError = function(el) {
            el.css('border', '')
        }

        $that.find('#supportopleiding_frm input').each(function() { fncReleaseError($(this)); });
        $that.find('#supportopleiding_frm').find('.alert-success').hide();
        $that.find('#supportopleiding_frm').submit(function(e) {
            e.preventDefault();

            var form = $(this);
            var error = false;
			var submitButton = form.find('input[type="submit"]');
			submitButton.prop('disabled', true);

			if (submitButton.prop('disabled')) {
				setTimeout(function() {
					submitButton.prop('disabled', false);
				}, 2000);
			}

            form.find('.alert-danger').remove();

            if($(this).find('#naamopleiding').val() == 'Naam van je opleiding *' || $(this).find('#naamopleiding').val() == '') {
                fncError($(this).find('#naamopleiding'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#naamopleiding'));
            }

            if($(this).find('#websiteopleiding').val() == 'Website van je opleiding *' || $(this).find('#websiteopleiding').val() == '') {
                fncError($(this).find('#websiteopleiding'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#websiteopleiding'));
            }

            if(!checkEmail($(this).find('#emailopleiding').val()) || $(this).find('#emailopleiding').val() == '') {
                fncError($(this).find('#emailopleiding'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#emailopleiding'));
            }

            if(!error) {
                $.post(inPath() + 'live/contact/tip-form-submit', $(this).serialize(), function (data) {
                    switch (data.message) {
                        case 'success' :
                            form.find('.alert-success').show();
                            break;
                        default :
                            form.find('.alert-success').after('<div class="alert alert-danger" role="alert"><strong>Er is een obekende fout opgetreden!</strong> Probeer het later nog een keer.</div>');
                            break;
                    }
                }, 'json');
            }

        });

        $that.find('#support_frm input').each(function() { fncReleaseError($(this)); });
        $that.find('#support_frm').find('.alert-success').hide();
        $that.find('#support_frm').submit(function(e) {
            e.preventDefault();

            var form = $(this);
            var error = false;
			var submitButton = form.find('input[type="submit"]');
			submitButton.prop('disabled', true);

			if (submitButton.prop('disabled')) {
				setTimeout(function() {
					submitButton.prop('disabled', false);
				}, 2000);
			}

            form.find('.alert-danger').remove();

            if($(this).find('#naam').val() == 'Naam *' || $(this).find('#naam').val() == '') {
                fncError($(this).find('#naam'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#naam'));
            }

            if(!checkEmail($(this).find('#mail').val()) || $(this).find('#mail').val() == '') {
                fncError($(this).find('#mail'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#mail'));
            }

            if($(this).find('#opmerkingenuitleg').val() == 'Opmerkingen / uitleg van het probleem *' || $(this).find('#opmerkingenuitleg').val() == '') {
                fncError($(this).find('#opmerkingenuitleg'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#opmerkingenuitleg'));
            }

            if(!error) {
                $.post(inPath() + 'live/contact/verification-contact-form-submit', $(this).serialize(), function (data) {
                    switch (data.message) {
                        case 'success' :
                            form.find('.alert-success').show();
                            break;
                        default :
                            form.find('.alert-success').after('<div class="alert alert-danger" role="alert"><strong>Er is een obekende fout opgetreden!</strong> Probeer het later nog een keer.</div>');
                            break;
                    }
                }, 'json');
            }


        });

        $that.find('#supportemail_frm input').each(function() { fncReleaseError($(this)); });
        $that.find('#supportemail_frm').find('.alert-success').hide();
        $that.find('#supportemail_frm').submit(function(e) {
            e.preventDefault();

            var form = $(this);
            var error = false;
			var submitButton = form.find('input[type="submit"]');
			submitButton.prop('disabled', true);

			if (submitButton.prop('disabled')) {
				setTimeout(function() {
					submitButton.prop('disabled', false);
				}, 2000);
			}

            form.find('.alert-danger').remove();

            if($(this).find('#naam').val() == 'Naam *' || $(this).find('#naam').val() == '') {
                fncError($(this).find('#naam'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#naam'));
            }

            if(!checkEmail($(this).find('#mail').val()) || $(this).find('#mail').val() == '') {
                fncError($(this).find('#mail'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#mail'));
            }

            if($(this).find('#opmerkingenuitleg').val() == 'Opmerkingen / uitleg van het probleem *' || $(this).find('#opmerkingenuitleg').val() == '') {
                fncError($(this).find('#opmerkingenuitleg'));
                error = true;
            }
            else {
                fncReleaseError($(this).find('#opmerkingenuitleg'));
            }

            if(!error) {
                $.post(inPath() + 'live/contact/verification-contact-form-submit', $(this).serialize(), function (data) {
                    switch (data.message) {
                        case 'success' :
                            form.find('.alert-success').show();
                            break;
                        default :
                            form.find('.alert-success').after('<div class="alert alert-danger" role="alert"><strong>Er is een obekende fout opgetreden!</strong> Probeer het later nog een keer.</div>');
                            break;
                    }
                }, 'json');
            }


        });

    })

// setTimeout(function() {
//     grecaptcha.ready(function () {
//         grecaptcha.execute('6LcbSNoUAAAAAMZbJOEJU1fTu680L1kbJFUf1oz-', {action: 'send_email'}).then(function (token) {
//             captcha_token = token;
//             alert(captcha_token);
//         });
//     });
// }, 15000);

});

/*
#class="verification-result"

#id="verification-success"
#id="verification-invalid-email"
#id="verification-used"
#id="verification-not-listed"
#id="verification-unknown"
#id="verification-not-agreed"
*/
